export default __webpack_public_path__ + "static/media/ADM.b718cf65.JPG";